var render = function render(_c,_vm){return _c('a',_vm._b({class:_vm.data.staticClass || '',style:(_vm.data.staticStyle || ''),attrs:{"target":"_blank","rel":"noopener"}},'a',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }